module.exports = __webpack_public_path__ + "static/media/supply-chain-management.2bd2e3fe.svg";